export const PAYMENT_METHOD = {
  CASH: 'CASH',
  DEBT: 'DEBT',
};

export const ORDER_TYPE = {
  SELLER: 'SELLER',
  CUSTOMER: 'CUSTOMER',
};
